exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2NkSOgcUn7Xcve{margin-top:8px;margin-bottom:8px}._2RfGKd4tIw-XUP{text-decoration:none}._1FoQzNHcvCPp1q{margin-top:0;margin-bottom:0}", ""]);

// exports
exports.locals = {
	"createCardButton": "_2NkSOgcUn7Xcve",
	"editTemplateLink": "_2RfGKd4tIw-XUP",
	"editTemplateButton": "_1FoQzNHcvCPp1q"
};